import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetEdenMessagesByRegardingFetchUrl,
  GetEdenMessagesByTaskFetchUrl,
  IEdenMessage,
} from "../../api/IEdenMessage";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import {
  EdenMessagesGridProps,
  EdenMessagesGridType,
} from "./EdenMessagesGridProps";

const GetUrlForEdenMessage = (
  profileNumber: string,
  edenMessage: IEdenMessage
) => {
  return `/licence-profile/${profileNumber}/compliance/eden-message/${edenMessage.edenmessageid}`;
};

const EdenMessagesGrid = ({
  edenMessagesType,
  profileNumber,
  taskId,
  regardingObjectId,
}: EdenMessagesGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (edenMessagesType) {
        case EdenMessagesGridType.TaskBasedEdenMessages:
          return GetEdenMessagesByTaskFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case EdenMessagesGridType.RegardingBasedEdenMessages:
          return GetEdenMessagesByRegardingFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  var relatedId = "";
  if (taskId) {
    relatedId = taskId;
  }

  if (regardingObjectId) {
    relatedId = regardingObjectId;
  }

  const fetchUrl = getFetchUrlFactory(relatedId);

  const tableColumnsBig: Column<Record<string, IEdenMessage>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("EDEN Message")}</span>
            </td>
            <td>
              <Link
                to={GetUrlForEdenMessage(profileNumber, rowInfo.row.original)}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date Received",
      accessor: "dateraised",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
    {
      Header: "Response from EPA",
      accessor: "response",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, IEdenMessage>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("EDEN Message")}</span>
            </td>
            <td>
              <Link
                to={GetUrlForEdenMessage(profileNumber, rowInfo.row.original)}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { EdenMessagesGrid };
